// Why someone sees the "no Voice" notice decides what it can tell them to do
// (ENG-2315). Seats are granted in Voice Setup, which only Suno staff can
// open, so a practice admin's way in is to ask Suno and everyone else asks an
// admin. A seat only works in the user's own practice, so after a practice
// switch the step is to switch back. A practice with no Voice at all has no
// seats to hand out.
export type VoiceSeatNoticeCase =
  | "staff"
  | "admin"
  | "suno"
  | "switched"
  | "practiceWithoutVoice";

type VoiceSeatNoticeCopy = { title: string; body: string };

const NOT_ON_YET = "Voice isn't turned on for you yet";

export const VOICE_SEAT_NOTICE_COPY: Record<
  VoiceSeatNoticeCase,
  VoiceSeatNoticeCopy
> = {
  staff: {
    title: NOT_ON_YET,
    body: "Ask your admin to add you as a Voice user."
  },
  admin: { title: NOT_ON_YET, body: "Ask Suno to add you as a Voice user." },
  suno: { title: NOT_ON_YET, body: "Add yourself in Voice Setup." },
  switched: {
    title: "Voice isn't available in this practice",
    body: "Switch back to your own practice to use Voice."
  },
  practiceWithoutVoice: {
    title: "Suno Voice isn't set up for this practice",
    body: "Ask your admin about adding Suno Voice."
  }
};

// The corner phone button names its state the way the notice does.
export const noVoiceSeatFabLabel = (title: string) => `Phone: ${title}`;

export const MESSAGE_SUNO_LABEL = "Message Suno";
export const MESSAGE_SUNO_TEXT = "Hi! Please add me as a Suno Voice user.";
// Where the notice points an admin when the in-app messenger is not loaded.
export const EMAIL_SUNO_LABEL = "Email Suno";
export const EMAIL_SUNO_HREF =
  "mailto:help@withsuno.com?subject=Please%20add%20me%20as%20a%20Suno%20Voice%20user";
export const OPEN_VOICE_SETUP_LABEL = "Add yourself in Voice Setup";
// The Users card of Voice Setup (`administration/voice-setup`), which scrolls
// itself into view on arrival.
export const VOICE_SETUP_USERS_ANCHOR = "voice-setup-users";
export const VOICE_SETUP_USERS_PATH = `/administration/voice-setup#${VOICE_SETUP_USERS_ANCHOR}`;
